import {
  Box,
  Typography
} from '@mui/material';
import ComponentTipoDecreto from 'components/forms/ComponentTipoDecreto';
import { ContainerFormFormik } from 'components/shared/container_form_formik';
import InputBooleanFormik from 'components/shared/custom_input_boolean_formik';
import InputComLabelFormik from 'components/shared/custom_input_label_formik';
import { useStep2 } from './useStep2';
import ButtonForm from 'components/buttons/button-form';


const Step2: React.FC = () => {
  const { formik, handleAvancar, handleVoltar, stepAtual, totalSteps } = useStep2();

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          mt: 4,
          mb: 4,
          fontSize: '24px',
          fontWeight: 400,
          textAlign: 'center'
        }}
      >
        Informações Complementares
      </Typography>
      <ContainerFormFormik title='Fundo Municipal' onSubmit={formik.handleSubmit}>
        <Box
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          gap={4}
          display={'flex'}
          flexDirection={'column'}
        >
          <InputBooleanFormik
            formik={formik}
            label='fundo_municipal_agricultura_familiar'
            labelTexto='O Município possui Fundo Municipal destinado ações para a Agricultura Familiar?'
          />

          {formik.values.fundo_municipal_agricultura_familiar && (
            <>
              <ComponentTipoDecreto
                formik={formik}
                label='tipo_publicacao'
                labelText='1. Informe o tipo da publicação:'
              />
              <InputComLabelFormik
                formik={formik}
                label='nro_publicacao'
                labelTexto='2. Número da publicação do instrumento legal que criou o Fundo:'
                placeholder='101'
                required
              />

              <InputComLabelFormik
                formik={formik}
                label='data_publicacao'
                labelTexto='3. Data da publicação do instrumento legal que criou o Fundo:'
                placeholder='10/01/2024'
                type='date'
                mask='data'
                required
              />
            </>
          )}
        </Box>
      </ContainerFormFormik>
      <ButtonForm
        disabled={formik.isSubmitting}
        onBack={handleVoltar}
        onAdvanced={handleAvancar}
        stepAtual={stepAtual}
        totalSteps={totalSteps}
      />
    </>
  );
};

export default Step2;
